import {
  Component, HostListener, Input, OnInit, OnChanges, ViewChild
} from '@angular/core';
@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})
export class CarouselSharedComponent implements OnInit, OnChanges {

  @Input() carouselData: any;
  showCarousel = false;
  isPrevDisable = true;
  isNextDisable = false
  setNextDisable = true;
  setPrevDisable = true;
  @Input() fromLiveClassPage: boolean;
  @Input() carouselOption: any = {
    minItems: 2
  };
  @Input() itemWidth: number = 338;
  @Input() height: number = 480;

  @ViewChild('myCarousel', { static: false }) myCarousel: any;
  show = false;
  test: any;
  showExtaDiv = true;



  constructor() { }

  ngOnInit(): void {

    console.log("carouselData: ", this.carouselData)

    this.carouselOption = {
      width: this.itemWidth,
      height: this.height,
      cardSpace: 10,
      isLoop: false,
      isFreeScroll: false
    }

    this.cardChangesOnResolution();

    // if(window.innerWidth > 1600){
    //   this.show = true
    // } else {
    //   this.show = false
    // }
    // console.log('carouselData' , this.carouselData, this.carouselOption);

    // this.carouselData = {
    //   width: 338,
    //   height: 480,
    //   cardSpace: 30,
    //   isLoop: false,
    //   data: [],
    //   dataType: 'class',
    //   dataModel:'recommended'
    // }

    if (this.myCarousel) {
      this.showCarousel = true;
      this.isNextDisable = this.myCarousel.isNextArrowDisabled();
      this.isPrevDisable = this.myCarousel.isPrevArrowDisabled();
    }




  }




  // @HostListener('window:scroll', ['$event'])
  // onScroll(e) {
  //     console.log(e);
  // }


  ngOnChanges() {
    this.showCarousel = false
    setTimeout(() => {
      this.showCarousel = true;
    }, 50);
  }

  //   $(function () {
  //     var scrollLeftPrev = 0;
  //     $('#scrollquestion').scroll(function () {

  //         var $elem=$('#scrollquestion');
  //         var newScrollLeft = $elem.scrollLeft(),
  //             width=$elem.width(),
  //             scrollWidth=$elem.get(0).scrollWidth;
  //         var offset=8;
  //         if (scrollWidth- newScrollLeft-width==offset) {
  //             alert('right end');
  //         }
  //         if (newScrollLeft === 0) {
  //             alert('left end');
  //         }

  //         scrollLeftPrev = newScrollLeft;
  //     });
  // });


  // @HostListener('window:resize', ['$event'])
  // onResize(event:any) {
  //   if(event.target.innerWidth > 1600){
  //     this.show = true
  //   } else {
  //     this.show = false
  //   }
  // }

  cardChangesOnResolution() {
    if (window.innerWidth <= 320) {
      this.showExtaDiv = false;
      // if(this.carouselData?.dataModel == 'teacherClass' && this.carouselData?.data?.length == 1) {
      //   this.carouselOption.width = 290;
      // } else {
        this.carouselOption.width = 265;
      // }
      this.carouselOption.isFreeScroll = false
    } else if (window.innerWidth <= 375) {
      this.showExtaDiv = false;
      // if(this.carouselData?.dataModel == 'teacherClass') {
      //   this.carouselOption.width = this.carouselData?.data?.length == 1 ? 340 : 320;
      // } else {
        this.carouselOption.width = 265;
      // }
      this.carouselOption.isFreeScroll = false
    } else if (window.innerWidth <= 425) {
      this.carouselOption.isFreeScroll = false
      this.showExtaDiv = false;
      // if(this.carouselData?.dataModel == 'teacherClass') {
      //   this.carouselOption.width = this.carouselData?.data?.length == 1 ? 390 : 370;
      // } else {
        this.carouselOption.width = 285;
      // }
    } else if (window.innerWidth <= 768) {
      this.showExtaDiv = false;
      // if(this.carouselData?.dataModel == 'teacherClass') {
      //   this.carouselOption.width = this.carouselData?.data?.length > 2 ? 340 : 360;
      // } else {
        this.carouselOption.width = 285;
      // }
      this.carouselOption.isFreeScroll = false
    } else {
      this.showExtaDiv = true;
      this.carouselOption.width = this.itemWidth;
      this.carouselOption.isFreeScroll = false
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (window.innerWidth <= 320) {
      this.showExtaDiv = false;
      // if(this.carouselData?.dataModel == 'teacherClass' && this.carouselData?.data?.length == 1) {
      //   this.carouselOption.width = 290;
      // } else {
        this.carouselOption.width = 265;
      // }
      this.carouselOption.isFreeScroll = false
    } else if (window.innerWidth <= 375) {
      this.showExtaDiv = false;
      // if(this.carouselData?.dataModel == 'teacherClass') {
      //   this.carouselOption.width = this.carouselData?.data?.length == 1 ? 340 : 320;
      // } else {
        this.carouselOption.width = 265;
      // }
      this.carouselOption.isFreeScroll = false
    } else if (window.innerWidth <= 425) {
      this.carouselOption.isFreeScroll = false
      this.showExtaDiv = false;
      // if(this.carouselData?.dataModel == 'teacherClass') {
      //   this.carouselOption.width = this.carouselData?.data?.length == 1 ? 390 : 370;
      // } else {
        this.carouselOption.width = 285;
      // }
    } else if (window.innerWidth <= 768) {
      this.carouselOption.isFreeScroll = false
      this.showExtaDiv = false;
      // if(this.carouselData?.dataModel == 'teacherClass') {
      //   this.carouselOption.width = this.carouselData?.data?.length > 2 ? 340 : 360;
      // } else {
        this.carouselOption.width = 285;
      // }
    } else {
      this.showExtaDiv = true;
      this.carouselOption.width = this.itemWidth;
      this.carouselOption.isFreeScroll = false
    }
  }


  next(e:any) {
    this.myCarousel.next();

    // if(this.isPrevDisable && this.setPrevDisable){
    // this.isPrevDisable = false;
    setTimeout(() => {
      this.setArrow(e)
    }, 300);
    // this.isPrevDisable = false;
    //  this.setPrevDisable = false;
    //  this.setNextDisable = true
    //   }
  }

  prev(e:any) {
    this.myCarousel.prev();
    // this.isNextDisable = false;
    setTimeout(() => {
      this.setArrow(e)
    }, 300);


    // this.isNextDisable = false;
    // if(this.isNextDisable && this.setNextDisable){

    // this.setNextDisable = false
    // this.setPrevDisable = true;
    // }

  }

  setArrow(e:any) {
    if (this.isNextDisable) {
      this.isNextDisable = false

    } else {
      this.isNextDisable = this.myCarousel.isNextArrowDisabled(e);
    }
    if (this.isPrevDisable) {
      this.isPrevDisable = false

    } else {
      this.isPrevDisable = this.myCarousel.isPrevArrowDisabled(e);

    }

    // if(this.isNextDisable || this.isPrevDisable){
    // this.myCarousel.handleTouchstart(e)
    // }
    //

  }




}
